<template>
  <article
    class="base-placeholder base-placeholder--empty"
    role="status"
    aria-live="polite"
  >
    <div class="base-placeholder__body">
      <h4 class="appMain--text mb-2">{{ title }}</h4>
      <slot>
        <p>
          <template v-if="text">
            {{ text }}
          </template>
          <template v-else-if="tooltipDescription">
            {{ tooltipDescription }}
          </template>
          <template v-else>
            There's nothing here yet. Start by creating something new.
          </template>
        </p>
      </slot>

      <div
        v-if="tooltipType && tooltipCategory"
        class="base-placeholder__video"
      >
        <VideoPlayer
          ref="player"
          :item="videoItem"
          :active="true"
          :popup="false"
          :taking="false"
          :testing="false"
          :options="clientPlayerOptions"
          class="mb-2"
        />
      </div>

      <div class="base-placeholder__actions">
        <UsageLimitCheck v-if="create" :limit="featureLimit">
          <v-btn
            class="base-placeholder__action"
            color="primary"
            depressed
            @click="create"
          >
            {{ `${buttonPrefix} ${buttonLabel}` }}
          </v-btn>
        </UsageLimitCheck>

        <slot name="actions" />
      </div>
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

import VideoPlayer from '@/views/lessons/lessonWidgets/videoWidget/VideoPlayer.vue';
import UsageLimitCheck from '@/components/programs/UsageLimitCheck.vue';

export default {
  name: 'PlaceholderEmptyState',
  components: {
    VideoPlayer,
    UsageLimitCheck,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon: '',
      fontIcon: false,
      title: 'Create Something Great',
      text: '',
      create: null,
      clear: null,
      buttonLabel: '',
      buttonPrefix: 'Create',
      entity: '',
      tooltipCategory: null,
      tooltipType: null,

      clientPlayerOptions: {
        presentMode: true,
        autoPlay: false,
      },
    };
  },
  mounted() {
    for (let key in this.config) {
      if (this.hasOwnProperty(key)) {
        this[key] = this.config[key];
      }
    }
  },
  computed: {
    ...mapGetters('cms', ['getSingleTooltip']),
    tooltipContent() {
      const { tooltipCategory, tooltipType } = this.config;
      if (!tooltipCategory || !tooltipType) return null;
      const tooltip = this.getSingleTooltip(tooltipCategory, tooltipType);
      return tooltip?.content || null;
    },

    tooltipVideo() {
      return this.tooltipContent?.video_link?.url || '';
    },

    featureLimit() {
      return this.config?.limit || null;
    },

    tooltipDescription() {
      return this.tooltipContent?.description || '';
    },

    videoItem() {
      return {
        values: {
          url: this.tooltipVideo || null,
          summary: {},
        },
      };
    },
  },
};
</script>
